"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillersRoutes = void 0;
const route_1 = require("../route");
class BillersRoutes extends route_1.Route {
    constructor() {
        super('billers');
    }
    getAll() {
        return this.get('/all');
    }
    getAllForCountry(country) {
        return this.get('/all', { country });
    }
    getItems(billerId) {
        return this.get('/items', { billerId });
    }
    getRecents() {
        return this.get('/recents');
    }
    lookup(data) {
        const { billerId, name, isFixedAmount, code, provider, attributes } = data;
        return this.post('/lookup', {
            billerId,
            name,
            isFixedAmount,
            code,
            provider,
            attributes
        });
    }
    pay(billPaymentId, amount) {
        return this.post('/payment', {
            billPaymentId,
            amount
        });
    }
}
exports.BillersRoutes = BillersRoutes;
//# sourceMappingURL=billers.js.map